import { useContext, useEffect, useState } from 'react';
import { isEmpty } from 'lodash-es';
import { useComponentConfig } from '@namespace/cms';
import { USER_ROLES, UserContext } from '@namespace/user';
import { IS_USE_PLEX_API } from '../../constants';
import { gamesStoreActions, useGamesStore } from '../../store';
import { useCasinoSettings } from '../useCasinoSettings';
import { useGetLoadFeedGamesCallback } from '../useGetLoadFeedGamesCallback';

const { GET_RECOMMENDED_GAMES_LIST } = gamesStoreActions;

export const useLoadRecommendedGames = (casinoType, feedName, limit) => {
  const [isLoading, setIsLoading] = useState(false);
  const recommendedGames = useGamesStore('recommendedGames');
  const { suggesterServiceEntityName } = useCasinoSettings(casinoType);
  const recommendedGamesIsLoaded =
    recommendedGames[suggesterServiceEntityName]?.isLoaded;
  const [user] = useContext(UserContext);
  const { role } = user;
  const { showRecommendedCategory } = useComponentConfig();

  const fetchGamesPlex = useGetLoadFeedGamesCallback();

  useEffect(() => {
    (async () => {
      if (
        role === USER_ROLES.USER &&
        !recommendedGamesIsLoaded &&
        showRecommendedCategory &&
        !isLoading
      ) {
        setIsLoading(true);

        const gamesLaunchIds = await GET_RECOMMENDED_GAMES_LIST(
          suggesterServiceEntityName
        );

        if (IS_USE_PLEX_API && !isEmpty(gamesLaunchIds)) {
          fetchGamesPlex({
            filter: { launchId: gamesLaunchIds.slice(0, limit), limit }
          });
        }
        setIsLoading(false);
      }
    })();
  }, [
    role,
    recommendedGamesIsLoaded,
    suggesterServiceEntityName,
    showRecommendedCategory,
    fetchGamesPlex,
    feedName
  ]);
};
